/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-expressions */
/* eslint-disable operator-linebreak */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable comma-dangle */
/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useState } from 'react';
import { FormikProvider, useFormik } from 'formik';
import { useHistory, useParams, useLocation } from 'react-router-dom';
import api from '../../services/api';
import {
  TextField,
  Grid,
  FormGroup,
  Card,
  CardContent,
  Tooltip,
  MenuItem,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import * as Yup from 'yup';
import Progress from '../../components/Progress';
import { useDispatch, useSelector } from 'react-redux';
import { setDisable } from '../../redux/disable';
import { setLoading } from '../../redux/loading';
import Success from '../../components/Snack/Success';
import Error from '../../components/Snack/Error';
import { useStyles } from '../../components/Styles';
import GroupButton from '../../components/Buttons/ButtonGroup';
import styleGlobal from '../../Global.module.css';
import NumberFormat from 'react-number-format';
import InfoIcon from '@mui/icons-material/Info';
import SelectFieldContext from 'components/CustomInputsInFormikContext/Select';
import { labelField } from 'utils';

function BankAccount() {
  const location = useLocation();
  const [openProgress, setOpenProgress] = useState(false);
  const [selectedParent, setSelectedParent] = useState(null);
  const [showCod, setShowCod] = useState(false);
  const [showParent, setShowParent] = useState(true);
  const s = '\xa0\xa0';
  const disable = useSelector((state) => state.disable.disable);
  const error = Error();
  const success = Success();
  const history = useHistory();
  const dispatch = useDispatch();
  let { id } = useParams();
  const classes = useStyles();

  useEffect(() => {
    if (location.state !== undefined) {
      if (location.state.customData) {
        setData(location.state.customData);
      } else if (location.state.data) {
        id = location.state.id;
        setData(location.state.data);
      }
    }
  }, [location]);

  function setData(data) {
    formik.setValues(data);

    setSelectedParent(data.parent);
    setShowCod(true);
    setShowParent(!!data.parent);
  }

  const getBank = useCallback(async (idParam) => {
    try {
      const { data } = await api.get(`/bank-account/${idParam}`);
      return data;
    } catch (e) {
      throw new Error(e);
    }
  });

  useEffect(() => {
    if (id) {
      getBank(id).then((data) => {
        formik.setValues({
          ...data,
        });
      });
    }
  }, []);

  const formik = useFormik({
    initialValues: {
      name: '',
      type: '',
      bank: null,
      agency: null,
      accountNumber: null,
      value: '0',
    },

    validationSchema: Yup.object({
      name: Yup.string().required('Campo Obrigatório'),
      type: Yup.string().required('Campo Obrigatório'),
      bank: Yup.string().required('Campo Obrigatório').nullable(),
      agency: Yup.string().required('Campo Obrigatório').nullable(),
      accountNumber: Yup.string().required('Campo Obrigatório').nullable(),
      value: Yup.number()
        .required('Campo Obrigatório')
        .moreThan(0, 'O valor deve ser maior que zero'),
    }),

    onSubmit: (values) => {
      if (values.type === 'Cofre' || values.type === 'Caixa') {
        values.bank = 'name-bank';
        values.agency = '1111-1';
        values.accountNumber = '11111-1';
      }

      dispatch(setDisable(true));
      dispatch(setLoading(true));
      request(values);
    },
  });

  async function request(data) {
    // envia os dados para api salvar no banco

    // evita enviar dados da conta sem '-' para o back
    data.accountNumber = data.accountNumber.toString().replace(/\-/g, '');
    data.agency = data.agency.toString().replace(/\-/g, '');

    try {
      id
        ? await api.put(`/bank-account/${id}`, { ...data })
        : await api.post('/bank-account', { ...data });
      success();
      history.push('/bank-accounts');
    } catch (err) {
      error();
    }
    dispatch(setDisable(false));
    dispatch(setLoading(false));
  }

  const isCurrentAccountOrSavingsAccount = ['Corrente', 'Poupança'].includes(
    formik.values.type
  );

  // Estilização do tooltip
  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#FFFFFF',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 300,
      fontSize: theme.typography.pxToRem(12),
      border: '1px solid #0367bf',
    },
  }))(Tooltip);

  return (
    <header className={styleGlobal.headerGlobal}>
      {openProgress ? <Progress /> : null}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        <form onSubmit={formik.handleSubmit}>
          <div className={classes.root}>
            <h2 style={{ marginBottom: '2rem' }}>
              Dados da Conta Bancária{' '}
              <HtmlTooltip
                title="Essa tela é possível gerenciar as suas contas e o caixa da fazenda."
                placement="right"
                arrow
                interactive
              >
                <InfoIcon color="primary" fontSize="inherit" />
              </HtmlTooltip>
            </h2>
            <CardContent style={{ padding: '0rem' }}>
              <FormGroup style={{ marginLeft: 0, marginRight: 0 }}>
                <Grid container spacing={2}>
                  <Grid
                    item
                    xs={12}
                    sm={isCurrentAccountOrSavingsAccount ? 12 : 4}
                    order={1}
                  >
                    <FormGroup>
                      <TextField
                        inputProps={{ maxLength: 100 }}
                        id="description"
                        name="description"
                        value={formik.values.name}
                        label={labelField('Descrição')}
                        variant="outlined"
                        onBlur={formik.handleBlur}
                        error={formik.touched.name && formik.errors.name}
                        helperText={formik.touched.name && formik.errors.name}
                        onChange={(e) => {
                          formik.setFieldValue('name', e.target.value);
                        }}
                        color="primary"
                      />
                    </FormGroup>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={isCurrentAccountOrSavingsAccount ? 2.4 : 4}
                    order={isCurrentAccountOrSavingsAccount ? 6 : 2}
                  >
                    <NumberFormat
                      inputProps={{ maxLength: 14 }}
                      InputLabelProps={{
                        style: { pointerEvents: 'auto' },
                        shrink: true,
                      }}
                      fullWidth
                      id="value"
                      label={labelField('Saldo da Conta')}
                      variant="outlined"
                      name="value"
                      thousandSeparator="."
                      decimalSeparator=","
                      decimalScale={2}
                      fixedDecimalScale
                      prefix="R$ "
                      disabled={id !== undefined}
                      value={formik.values.value}
                      onValueChange={(values) => {
                        formik.values.value = values.floatValue;
                      }}
                      onBlur={formik.handleBlur}
                      customInput={TextField}
                      error={formik.touched.value && formik.errors.value}
                      helperText={formik.touched.value && formik.errors.value}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={isCurrentAccountOrSavingsAccount ? 2.4 : 4}
                    order={3}
                  >
                    <FormikProvider value={formik}>
                      <SelectFieldContext
                        name="type"
                        disabled={id}
                        id="type"
                        label={labelField('Tipo de Conta')}
                      >
                        <MenuItem key={1} value="Corrente">
                          Corrente
                        </MenuItem>
                        <MenuItem key={2} value="Poupança">
                          Poupança
                        </MenuItem>
                        <MenuItem key={3} value="Cofre">
                          Cofre
                        </MenuItem>
                        <MenuItem key={4} value="Caixa">
                          Caixa
                        </MenuItem>
                      </SelectFieldContext>
                    </FormikProvider>
                  </Grid>
                  {isCurrentAccountOrSavingsAccount && (
                    <Grid
                      item
                      xs={12}
                      sm={2.4}
                      order={isCurrentAccountOrSavingsAccount ? 2 : 4}
                    >
                      <TextField
                        inputProps={{ maxLength: 51 }}
                        fullWidth
                        id="bank"
                        name="bank"
                        value={formik.values.bank}
                        label={labelField('Nome do Banco')}
                        variant="outlined"
                        onBlur={formik.handleBlur}
                        error={formik.touched.bank && formik.errors.bank}
                        helperText={formik.touched.bank && formik.errors.bank}
                        onChange={(e) => {
                          formik.setFieldValue('bank', e.target.value);
                        }}
                        color="primary"
                      />
                    </Grid>
                  )}

                  {isCurrentAccountOrSavingsAccount && (
                    <Grid
                      item
                      xs={12}
                      sm={2.4}
                      order={isCurrentAccountOrSavingsAccount ? 3 : 6}
                    >
                      <NumberFormat
                        fullWidth
                        format="####-#"
                        id="agency"
                        label={labelField('Número da Agência')}
                        variant="outlined"
                        name="agency"
                        disabled={id !== undefined}
                        value={formik.values.agency}
                        onBlur={formik.handleBlur}
                        error={formik.touched.agency && formik.errors.agency}
                        helperText={
                          formik.touched.agency && formik.errors.agency
                        }
                        onChange={(e) => {
                          formik.setFieldValue('agency', e.target.value);
                        }}
                        customInput={TextField}
                      />
                    </Grid>
                  )}

                  {isCurrentAccountOrSavingsAccount && (
                    <Grid
                      item
                      xs={12}
                      sm={2.4}
                      order={isCurrentAccountOrSavingsAccount ? 4 : 5}
                    >
                      <NumberFormat
                        // disabled={true}
                        fullWidth
                        format="#####-#"
                        id="account-number"
                        label={labelField('Número da Conta')}
                        value={formik.values.accountNumber}
                        variant="outlined"
                        onBlur={formik.handleBlur}
                        error={
                          formik.touched.accountNumber &&
                          formik.errors.accountNumber
                        }
                        helperText={
                          formik.touched.accountNumber &&
                          formik.errors.accountNumber
                        }
                        onChange={(e) => {
                          formik.setFieldValue('accountNumber', e.target.value);
                        }}
                        customInput={TextField}
                      />
                    </Grid>
                  )}
                </Grid>
              </FormGroup>
            </CardContent>
          </div>

          <GroupButton
            deleteRoute="/bank-account/"
            routeDelete="/bank-account"
            returnRoute="/bank-account"
            id={id}
            disable={disable}
            message="A exclusão pode levar a exclusão de objetos que dependam dela. Tem certeza que deseja excluir?"
          />
        </form>
      </Card>
    </header>
  );
}

export default BankAccount;
